import { Component, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AlphaSharedModule, PrimeNGModules } from '../../../shared/alpha-shared.module';

@Component({
    selector: 'app-variables-modal',
    standalone: true,
    imports: [AlphaSharedModule, ...PrimeNGModules],
    templateUrl: './variables-modal.component.html',
    styleUrl: './variables-modal.component.scss',
    host: {
        class: 'p-1',
    },
})
export class VariablesModalComponent {
    private config = inject(DynamicDialogConfig);

    variables: any;
    ngOnInit() {
        this.variables = this.config.data['variables'];
    }
}
